export default __webpack_public_path__ + "static/okr1-03c6601cc29cf64f66655f61cf3c0dbd.jpeg";